import React, { useState, useEffect } from 'react';
import { clienteService } from '../services/api';
import ClienteTable from '../components/ClienteTable';
import Pagination from '../components/Pagination';
import Filters from '../components/Filters';

const ClientesPage = ({ initialLocalidade, onNavigateToDashboard }) => {
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [localidade, setLocalidade] = useState('');
  const [estatisticas, setEstatisticas] = useState(null);
  const [pagination, setPagination] = useState({ page: 1, limit: 50, total: 0, totalPages: 0 });
  const [currentFetchFunction, setCurrentFetchFunction] = useState(null);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('');

  useEffect(() => {
    if (initialLocalidade) {
      if (initialLocalidade === 'vila-isabel') {
        handleVilaIsabel();
      } else if (initialLocalidade === 'nilopolis') {
        handleNilopolis();
      }
    }
  }, [initialLocalidade]);

  const fetchClientes = async (fetchFunction, localidadeNome, params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchFunction(params);
      if (response.success) {
        setClientes(response.data);
        setLocalidade(response.localidade || localidadeNome);
        setEstatisticas(response.estatisticas || null);
        setPagination(response.pagination || { page: 1, limit: 50, total: 0, totalPages: 0 });
      } else {
        setError('Erro ao buscar dados');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao conectar com o servidor');
    } finally {
      setLoading(false);
    }
  };

  const handleVilaIsabel = () => {
    setCurrentFetchFunction(() => clienteService.getVilaIsabel);
    setSearch('');
    setStatusFilter('');
    fetchClientes(clienteService.getVilaIsabel, 'Vila Isabel', { page: 1, limit: 50 });
  };

  const handleNilopolis = () => {
    setCurrentFetchFunction(() => clienteService.getNilopolis);
    setSearch('');
    setStatusFilter('');
    fetchClientes(clienteService.getNilopolis, 'Nilópolis', { page: 1, limit: 50 });
  };

  const handleAll = () => {
    setCurrentFetchFunction(() => clienteService.getAll);
    setSearch('');
    setStatusFilter('');
    fetchClientes(clienteService.getAll, 'Todos', { page: 1, limit: 50 });
  };

  const handlePageChange = (newPage) => {
    if (currentFetchFunction) {
      const params = { 
        page: newPage, 
        limit: pagination.limit,
        search: search || undefined,
        status: statusFilter || undefined
      };
      fetchClientes(currentFetchFunction, localidade, params);
    }
  };

  const handleSearch = (value) => {
    setSearch(value);
  };

  const handleStatusChange = (value) => {
    setStatusFilter(value);
  };

  const handleApplyFilters = () => {
    if (currentFetchFunction) {
      const params = { 
        page: 1, 
        limit: pagination.limit,
        search: search || undefined,
        status: statusFilter || undefined
      };
      fetchClientes(currentFetchFunction, localidade, params);
    }
  };

  const handleClearFilters = () => {
    setSearch('');
    setStatusFilter('');
    if (currentFetchFunction) {
      fetchClientes(currentFetchFunction, localidade, { page: 1, limit: pagination.limit });
    }
  };

  useEffect(() => {
    if (currentFetchFunction) {
      const timer = setTimeout(() => {
        handleApplyFilters();
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [search, statusFilter]);

  return (
    <>
      <div className="page-header">
        <button className="btn-back" onClick={onNavigateToDashboard}>
          ← Voltar ao Dashboard
        </button>
      </div>

      <div className="controls">
        <button 
          className="btn btn-primary" 
          onClick={handleVilaIsabel}
          disabled={loading}
        >
          📍 Vila Isabel
        </button>
        <button 
          className="btn btn-primary" 
          onClick={handleNilopolis}
          disabled={loading}
        >
          📍 Nilópolis
        </button>
        <button 
          className="btn btn-primary" 
          onClick={handleAll}
          disabled={loading}
        >
          📋 Todos os Clientes
        </button>
      </div>

      {estatisticas && !loading && (
        <div className="stats">
          {localidade && (
            <div className="stat-card">
              <h3>📍 Localidade</h3>
              <p className="stat-localidade">{localidade}</p>
            </div>
          )}
          <div className="stat-card">
            <h3>📊 Total</h3>
            <p>{estatisticas.total}</p>
          </div>
          <div className="stat-card stat-active">
            <h3>✅ Ativos</h3>
            <p>{estatisticas.ativos}</p>
          </div>
          <div className="stat-card stat-courtesy">
            <h3>🎁 Cortesia</h3>
            <p>{estatisticas.cortesias || 0}</p>
          </div>
          <div className="stat-card stat-warning">
            <h3>⚠️ Inadimplência</h3>
            <p>{estatisticas.inadimplentes}</p>
          </div>
          <div className="stat-card stat-install">
            <h3>🔧 A Instalar</h3>
            <p>{estatisticas.aInstalar}</p>
          </div>
          <div className="stat-card stat-cancelled">
            <h3>❌ Cancelados</h3>
            <p>{estatisticas.cancelados}</p>
          </div>
        </div>
      )}

      {loading && <div className="loading">⏳ Carregando dados...</div>}

      {error && <div className="error">❌ {error}</div>}

      {clientes.length > 0 && (
        <>
          <Filters 
            search={search}
            onSearchChange={handleSearch}
            status={statusFilter}
            onStatusChange={handleStatusChange}
            onClear={handleClearFilters}
          />

          <ClienteTable clientes={clientes} />

          <Pagination 
            currentPage={pagination.page}
            totalPages={pagination.totalPages}
            onPageChange={handlePageChange}
          />

          <div className="pagination-info">
            Mostrando {clientes.length} de {pagination.total} clientes
          </div>
        </>
      )}
    </>
  );
};

export default ClientesPage;

